import { fetchConfig } from '@theme/utilities';
import { CartAddEvent } from '@theme/events';

const RESET_DELAY = 2000;


class BuySwatchButton extends HTMLElement {
  /** @type {AbortController | null} */
  #abortController = null;

  connectedCallback() {
    this.#abortController = new AbortController();
    const opts = { signal: this.#abortController.signal };

    this.#button.addEventListener('click', this.#handleClick, opts);
  }

  disconnectedCallback() {
    this.#abortController?.abort();
    this.#abortController = null;
  }

  /** @returns {HTMLButtonElement} */
  get #button() {
    return /** @type {HTMLButtonElement} */ (this.querySelector('button') || this);
  }

  /**
   * Returns the variant ID from the data attribute, or undefined.
   * @returns {string | undefined}
   */
  get #selectedVariantId() {
    return this.getAttribute('data-variant-id') || undefined;
  }

  #handleClick = () => {
    const btn = this.#button;
    if (btn.disabled) return;

    const variantId = this.#selectedVariantId;
    if (!variantId) return;

    const originalText = btn.textContent?.trim() || '';
    btn.disabled = true;
    btn.textContent = Theme.translations.swatch_adding || 'Adding...';

    const formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', '1');

    // The swatch's own Searchspring IDs (snippets/searchspring-product-ids.liquid).
    const ssParent = this.getAttribute('data-ss-parent');
    if (ssParent) formData.append('properties[_ss_parent]', ssParent);

    const fetchCfg = fetchConfig('javascript', { body: formData });

    fetch(Theme.routes.cart_add_url, {
      ...fetchCfg,
      headers: { ...fetchCfg.headers, Accept: 'text/html' },
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.status) throw new Error(data.description);
        btn.textContent = Theme.translations.swatch_added || 'Added!';
        document.dispatchEvent(
          new CartAddEvent({}, variantId, { source: 'product-form-component', itemCount: 1 })
        );
      })
      .catch(() => {
        btn.textContent = Theme.translations.swatch_error || 'Could not add swatch';
      })
      .finally(() => {
        setTimeout(() => {
          btn.textContent = originalText;
          btn.disabled = false;
        }, RESET_DELAY);
      });
  };
}

if (!customElements.get('buy-swatch-button')) {
  customElements.define('buy-swatch-button', BuySwatchButton);
}
